import StoredLayout from '../../layouts/StoredLayout'
import Images from './Images'
export default StoredLayout(Images)
